import { UpgradeflgResponse } from '@/types/api/mypage/g10AcceptanceJudgementInfo';
import api from '@/utils/api';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import { AxiosResponse } from 'axios';
import { useCallback } from 'react';

/** 10Gアップグレード可否判定APIのURL */
const apiUrl = ApiUrl.Read.UPGRADE_ACCEPTANCE_JUDGEMENT;

/**
 * 10Gアップグレード可否判定APIの呼び出しフック。
 * そもそもアップグレード対象契約かどうかを最初に判定する。
 *
 * @returns execute - API実行関数
 */
const useGetUpgradeAcceptanceJudgemnent = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<UpgradeflgResponse>> => {
    const headers = await getSigV4HeadersForGet(apiUrl);
    return api.get(apiUrl, headers);
  }, []);

  return { execute };
};

export default useGetUpgradeAcceptanceJudgemnent;
